/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cmspost_Category1Inputs */

const vi_cmspost_category1 = /** @type {(inputs: Cmspost_Category1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chuyên mục`)
};

/**

* @param {Cmspost_Category1Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
const cmspost_category1 = /** @type {((inputs?: Cmspost_Category1Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cmspost_Category1Inputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_cmspost_category1(inputs)
});
export { cmspost_category1 as "cmsPost_category" }